import { useState, useEffect } from 'react';
import { Link } from 'react-router';

import Icon from '../../../../components/Icon';
import dialogs from '../../../../dialogs';
import currency from '../../../../utils/currency';
import toast from '../../../../utils/toast';
import styles from './Activity.module.scss';

const DEFAULT_LOCKED_MESSAGE = 'This activity is currently locked.';

const ACTIONS = {
  'url_submit': {
    icon: 'share',
    dialog: dialogs.campaigns.activities.UrlSubmit,
  },
  'url_submit_plus': {
    icon: 'share',
    dialog: dialogs.campaigns.activities.UrlSubmitPlus,
  },
  'text_submit': {
    icon: 'share',
    dialog: dialogs.campaigns.activities.TextSubmit,
  },
  'media_upload': {
    icon: 'share',
    dialog: dialogs.campaigns.activities.MediaUpload,
  },
  'receipt_upload': {
    icon: 'share',
    dialog: dialogs.campaigns.activities.MediaUpload,
  },
  'review_links': {
    icon: 'star',
    dialog: dialogs.campaigns.activities.ReviewLinks,
  },
  'review_yotpo': {
    icon: 'star',
    dialog: dialogs.campaigns.activities.ReviewYotpo,
  },
  'review_wholescale': {
    icon: 'star',
    dialog: dialogs.campaigns.activities.ReviewWholescale,
  },
  'tiktok_publish': {
    icon: 'mobile',
    dialog: dialogs.campaigns.activities.TiktokPublish,
  },
};

const STATUS = {

  // Missing
  '_M': {
    action: {
      className: styles._missing,
      disabled: false,
      label: 'Start',
    },
  },

  // Assigned
  'A': {
    action: {
      className: styles.assigned,
      disabled: false,
      label: 'Start',
    },
  },

  // Submitted
  'S': {
    action: {
      className: styles.submitted,
      disabled: false,
      label: 'Edit',
    },
  },

  // Accepted
  'D': {
    action: {
      className: styles.accepted,
      disabled: true,
      label: 'Completed',
    },
  },

  // Rejected
  'R': {
    action: {
      className: styles.rejected,
      disabled: false,
      label: 'Try Again',
    },
  },
};

const Activity = ({ campaign, activity, handle }) => {

  const status = activity.user.status || '_M';

  /*
   * dialog
   */

  const { dialog, setDialog } = dialogs.utils.useDialog();
  const [ dialogShow, setDialogShow ] = useState();

  useEffect(() => {

    const [ kind_1, text_1, kind_2 , text_2, ...rest ] = (dialog || '').split(' ');

    const value = (
      kind_1 === 'campaign' &&
      text_1 === (campaign.id + '') &&
      kind_2 === 'activity' &&
      text_2 === (activity.id + '') &&
      rest.length === 0
    );

    if (value && status === 'D') {
      setDialog();
      return;
    }

    setDialogShow(value);

  }, [dialog, setDialog, campaign, activity, status]);

  /*
   * content
   */

  const Dialog = ACTIONS[activity.action].dialog;

  return (
    <div className={styles.root}>
      {
        dialogShow
        ? (
          <Dialog
            campaign={campaign}
            activity={activity}
            handle={handle}
          />
        )
        : null
      }

      <div className={styles.info}>
        <Icon name={ACTIONS[activity.action].icon} />
        <div className={styles.content}>

          {
            activity.reward.currency &&
            activity.reward.amount && (
              <div className={styles.reward}>
                {`
                  ${currency.repr(activity.reward.currency)}
                  ${activity.reward.amount}
                  Reward
                `}
              </div>
            )
          }

          <div
            role='heading'
            aria-level='3'
            className={styles.descr}
            dangerouslySetInnerHTML={{
              __html: (
                activity.descr
                ? activity.descr
                : activity.title.external
              ),
            }}
          />
        </div>
      </div>

      {
        activity.user.status === 'S' && (
          <div className={`${styles.comment} ${styles.normal}`}>
            We are reviewing your submission.
          </div>
        )
      }

      {
        activity.user.comment &&
        activity.user.status === 'R' && (
          <div className={`${styles.comment} ${styles.error}`}>
            {activity.user.comment}
          </div>
        )
      }

      {
        activity.user.comment &&
        activity.user.status === 'D' && (
          <div className={`${styles.comment} ${styles.success}`}>
            {activity.user.comment}
          </div>
        )
      }

      {
        activity.user.closed
        ? (
          <Link
            className={`
              ${styles.action}
              ${styles._disabled}
              ${styles._blocked}
            `}
            aria-label={activity.title.external}
            onClick={(event) => event.preventDefault()}
            to={`?dialog=campaign+${campaign.id}+activity+${activity.id}`}>
            Submission Closed
          </Link>
        )
        : (
          <Link
            className={`
              ${styles.action}
              ${STATUS[status].action.className}
              ${STATUS[status].action.disabled ? styles._disabled : ''}
              ${activity.user.enable ? '' : styles._blocked}
            `}
            aria-label={activity.title.external}
            onClick={(event) => {
              if (!activity.user.enable) {
                event.preventDefault();
                toast.show(
                  toast.KIND.WARNING,
                  activity.expr_message || DEFAULT_LOCKED_MESSAGE,
                );
              }
            }}
            to={`?dialog=campaign+${campaign.id}+activity+${activity.id}`}>

            {
              activity.user.enable
              ? STATUS[status].action.label
              : 'Locked'
            }

          </Link>
        )
      }
    </div>
  );
};

export default Activity;